import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";
import { FaSave } from "react-icons/fa";
import { useGetInvoicesListQuery } from "../../../Service/invoices";
import { formatDateString } from "../Customer/Utils";
import { formatWord } from "../Utils/utils";
import ModalComponent from "../Appoinment/component/ModalComponent";
import InvoiceDetails from "./InvoiceDetails";

const TableLists = ({ order, orderBy }) => {
  const [show, setShow] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const { data, refetch, isLoading } = useGetInvoicesListQuery({
    refetchOnMountOrArgChange: true,
  });

  const handleShow = (row) => {
    setShow(true);
    setInvoiceData(row);
  };

  // const dummyData = [
  //   {
  //     sNo: 1,
  //     patient: "John Doe",
  //     branch: "Main",
  //     consultant: "Dr. Smith",
  //     procedures: "Procedure",
  //     dateTime: "21 FEB 2023 | 08:24 AM",
  //     amount: 2500.0,
  //   },
  //   {
  //     sNo: 2,
  //     patient: "Jane Doe",
  //     branch: "Main",
  //     consultant: "Dr. Clark",
  //     procedures: "Procedure",
  //     dateTime: "21 FEB 2023 | 08:24 AM",
  //     amount: 2500.0,
  //   },
  //   {
  //     sNo: 3,
  //     patient: "Alice",
  //     branch: "North",
  //     consultant: "Dr. Adams",
  //     procedures: "Procedure",
  //     dateTime: "21 FEB 2023 | 08:24 AM",
  //     amount: 2500.0,
  //   },
  //   {
  //     sNo: 4,
  //     patient: "Bob",
  //     branch: "South",
  //     consultant: "Dr. Jones",
  //     procedures: "Procedure",
  //     dateTime: "21 FEB 2023 | 08:24 AM",
  //     amount: 2500.0,
  //   },
  // ];

  return (
    <>
      {data?.data?.map((row, i) => (
        <TableRow key={i} role="checkbox">
          <TableCell align="left">{i + 1}</TableCell>
          <TableCell align="left">{row.patient}</TableCell>
          <TableCell align="left">{row.branch}</TableCell>
          <TableCell align="left">{row.consultant}</TableCell>
          {/* <TableCell align="left">{formatWord(row.procedures)}</TableCell> */}
          <TableCell align="left">
            {formatDateString(row.latestAppointmentDateTime)}
          </TableCell>
          <TableCell align="left">{row.totalAmount || "_"}</TableCell>
          <TableCell align="left" onClick={() => handleShow(row)}>
            <FaSave />
          </TableCell>
        </TableRow>
      ))}
      <ModalComponent
        size="lg"
        title="Invoice"
        show={show}
        body={<InvoiceDetails data={invoiceData} setShow={setShow} />}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default TableLists;
